exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ivu-shrinkable-menu{height:100%;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--10-1!./node_modules/postcss-loader/lib??ref--10-2!./node_modules/less-loader/dist/cjs.js??ref--10-3!./src/components/shrinkable-menu/styles/menu.less
// module id = lu/3
// module chunks = 243